import { Button, Card, Stack, TextField } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { useNotify, useTranslate } from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { paths } from '../../../../../routes/paths';
import { PermissionGuard } from '../../../../../routes/components/permission-guard';
import ErrorPage403 from '../../../../error/403';
import { SECTION_CARD_SX } from '../shared/sectionCardSx';
import { SectionOpenSessions } from './SectionOpenSessions';

export default function BlindBoxOpenSessionsList() {
  const t = useTranslate();
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <PermissionGuard resource="bb-open-sessions" action="read" fallback={<ErrorPage403 />}>
      <DashboardContent maxWidth={false}>
        <CustomBreadcrumbs
          heading={t('module.blindBox.openSessions')}
          links={[
            { name: t('module.blindBox.title'), href: paths.blindBox.overview.root },
            { name: t('module.blindBox.openSessions') },
          ]}
          action={
            <Button size="small" variant="outlined" onClick={() => setRefreshKey((k) => k + 1)}>
              {t('module.blindBox.refreshAll')}
            </Button>
          }
        />
        <Card variant="outlined" sx={{ ...SECTION_CARD_SX, mt: 2 }}>
          <SectionOpenSessions refreshKey={refreshKey} />
        </Card>
      </DashboardContent>
    </PermissionGuard>
  );
}

